/**
 * MapProvider component for the Needs Map
 * Combines all map-related contexts
 */

import React from 'react';
import { MapStateProvider } from './MapStateContext';
import { MapLayoutProvider } from './MapLayoutContext';
import { MapExtractionProvider } from './MapExtractionContext';
import { MapUIProvider } from './MapUIContext';

/**
 * MapProvider props
 */
interface MapProviderProps {
  children: React.ReactNode;
  initialMapId?: string;
}

/**
 * MapProvider component
 * Combines all map-related contexts
 * The order of providers is important to avoid circular dependencies
 */
const MapProvider: React.FC<MapProviderProps> = ({ 
  children,
  initialMapId
}) => {
  return (
    <MapLayoutProvider>
      <MapStateProvider initialMapId={initialMapId}>
        <MapExtractionProvider>
          <MapUIProvider>
            {children}
          </MapUIProvider>
        </MapExtractionProvider>
      </MapStateProvider>
    </MapLayoutProvider>
  );
};

export default MapProvider;

/**
 * Export all map-related hooks
 */
export { useMapState } from './MapStateContext';
export { useMapLayout } from './MapLayoutContext';
export { useMapExtraction } from './MapExtractionContext';
export { useMapUI } from './MapUIContext';
export type { LayoutType } from './MapLayoutContext';